import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Loadable } from '../../store/types';
import { Order } from '../../types/items';
import { useTitle } from '../../hooks';
import {
  ItemFormReact,
  ViewFrame,
} from '../../components';
import yup from '../../utility/yup';
import OrderFields from './OrderFields';

type Props = {
  creatingMode?: boolean;
  record: Loadable<Order>;
  onSubmit: (data: Order) => void;
};

const orderSchema = yup.object().shape({
  title: yup.string().trim()
    .required()
    .label('Title')
    .matches(/^[\p{Alpha}\s+(.\-`'&)]+$/u, 'Title has a wrong symbols'),
  user_id: yup.number().min(1, 'User is required').label('User'),
  notes: yup.string().trim().label('Notes'),
  invoice_id: yup.string().required().trim().label('Invoice'), // TODO

});

const OrderForm = ({
  creatingMode = false,
  record: { loading, data },
  onSubmit,
}: Props) => {
  const title = data?.title || 'New Order';
  useTitle(title);
  const dispatch = useDispatch();

  useEffect(() => {
    const hotKeyList = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key?.toLocaleLowerCase() === 'l') {
        event.preventDefault();
        dispatch(push('/dashboard/admin/orders'));
      }
    };
    window.addEventListener('keydown', hotKeyList);

    return () => {
      window.removeEventListener('keydown', hotKeyList);
    };
  }, [dispatch]);

  return (
    <ViewFrame
      loading={loading}
      title={title}
      backToListLink
    >
      <ItemFormReact
        creatingMode={creatingMode}
        initialValues={data}
        validationSchema={orderSchema}
        onSubmit={onSubmit}
        loading={loading}
        //editPermitted={Boolean(canEdit)}
        preventCancelChanges
        // enableReinitialize
      >
        <OrderFields creatingMode={creatingMode} />
      </ItemFormReact>
    </ViewFrame>
  );
};

export default OrderForm;
